import type { ListingRequestListFilters } from '../types/listingRequestTypes'

// Query-keys factory for the listing-request module. The create mutation
// invalidates `lists()`; future seller-action mutations (Phase B) invalidate
// `detail(id)` + `lists()`.
export const listingRequestKeys = {
  all: ['listingRequest'] as const,
  lists: () => [...listingRequestKeys.all, 'list'] as const,
  // `page` is intentionally NOT part of the key — useInfiniteQuery manages
  // pagination via pageParam.
  list: (filters: ListingRequestListFilters) =>
    [...listingRequestKeys.lists(), filters] as const,
  details: () => [...listingRequestKeys.all, 'detail'] as const,
  detail: (id: string) => [...listingRequestKeys.details(), id] as const,
  timeline: (id: string) => [...listingRequestKeys.detail(id), 'timeline'] as const,
  agreements: (id: string) => [...listingRequestKeys.detail(id), 'agreements'] as const,
}
